<script lang="ts">
  export let color = '#2C83A8'
</script>

<svg
  width="158"
  height="195"
  viewBox="0 0 158 195"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M157.319 79.266C157.319 128.84 99.2969 179.881 82.9207 193.305C80.4513 195.329 76.8864 195.329 74.3984 193.305C58.0222 179.881 0 128.84 0 79.266C0 35.819 35.2218 0.597168 78.6688 0.597168C122.116 0.597168 157.338 35.819 157.338 79.266H157.319Z"
    fill={color}
  />
</svg>
